export const popupWindow = async (err) => {
  if (err) {
    console.error(err);
  }

  const popupCloseButton = document.querySelector('.close-btn');
  if (popupCloseButton) {
    popupCloseButton.addEventListener('click', (event) => {
      const popupWindow = document.querySelector('.popup-window');
      if (popupWindow) {
        popupWindow.classList.remove('open');
        setCookie('popup-window-closed', 'true', 5);
      }
      event.preventDefault();
    });
  }

  // Set the cookie to expire in 5 days
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }
  // Get the cookie value
  function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  // Check if the cookie is set
  checkCookie();
  function checkCookie() {
    let popupWindow = document.querySelector('.popup-window');
    if (getCookie('popup-window-closed')) {
      //let cookiename = getCookie('popup-window-closed'),

      if (popupWindow) {
        popupWindow.classList.remove('open');
      }
    } else {
      if (popupWindow) {
        popupWindow.classList.add('open');
      }
    }
  }
};

import.meta.webpackHot?.accept(popupWindow);
